<template>
  <div class="group-buy-block-component">
    <block-header :rule="rule"
                  :startTime="startTime"
                  :endTime="endTime"
                  :show-countdown="showCountdown"
    />
    <div v-if="list.length > 0"
         class="desc-container"
    >
      <div class="desc">{{ desc }}</div>
      <ym-button v-if="list.length > 2"
                 class="more-btn"
                 size="small"
                 type="text"
                 @click="handleShowTeamListPopup"
      >
        更多
        <ym-icon class="icon"
                 name="right"
        />
      </ym-button>
    </div>
    <block-team-list v-if="list.length > 0"
                     :id="id"
                     :list="teamList"
                     :start-time="startTime"
    />

    <center-popup class="team-list-popup"
                  :show.sync="showTeamListPopup"
                  title="以下小伙伴正在拼团"
                  type="gradient"
                  size="large"
    >
      <block-team-list :id="id"
                       :list="list"
                       :start-time="startTime"
      />
      <div class="team-list-footer">
        仅显示{{ maxListNum }}个正在开团的人
      </div>
    </center-popup>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import BlockHeader from '@/pages/GroupBuy/components/ProductDetailBlockHeader';
  import BlockTeamList from '@/pages/GroupBuy/components/BlockTeamList';
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'ProductDetailGroupBuyBlock',
    components: {
      'ym-button': Button,
      BlockHeader,
      BlockTeamList,
      CenterPopup,
    },
    data() {
      return {
        showTeamListPopup: false,
      };
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      desc: {
        type: String,
        default: '开团后邀请好友参团，逾时人数不足自动退款。',
      },
      rule: {
        type: String,
        required: true,
      },
      startTime: {
        type: Number,
        required: true,
        default: 0,
      },
      endTime: {
        type: Number,
        required: true,
        default: 0,
      },
      list: {
        type: Array,
        required: true,
      },
      maxListNum: {
        type: Number,
        required: true,
      },
      showCountdown: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      teamList() {
        return this.list.slice(0, 2);
      },
    },
    methods: {
      handleShowTeamListPopup() {
        this.showTeamListPopup = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .group-buy-block-component {
    background-color: @color-white;
  }

  .desc-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: @size-small @size-base;
    font-size: @font-size-small;
    color: @color-text-lighter;

    .desc {
      color: @color-text-light;
    }

    .more-btn {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: auto;
      min-width: auto;
      padding: 0;
      color: @color-text-lighter;
      font-size: inherit;
    }

    .icon {
      margin-left: -8px;
    }
  }

  .team-list-popup {
    width: 630px;
  }

  .team-list-footer {
    text-align: center;
    font-weight: @font-weight-primary;
    font-size: @font-size-base;
    line-height: 1;
    padding: @size-small 0;
    border-top: @border-base;
    color: @color-text-lighter;
  }
</style>
